import * as ActionTypes from '../actionTypes';

// API
import * as HttpApi from '../Api/index';

export const actionTypes = ActionTypes;

//////////////////
///// GET ////////
//////////////////
export const getList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDISTRIBUTOR_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getCount = (params) => {
	return (dispatch) => {
		return HttpApi.get('GET_ACCOUNT_COUNT', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getById = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDISTRIBUTOR_GET', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getSelectedList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDISTRIBUTOR_SELECTED_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// POST ///////
//////////////////
export const create = (params) => {
	return (dispatch) => {
		return HttpApi.post('eDISTRIBUTOR_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const selectedCreate = (params) => {
	return (dispatch) => {
		return HttpApi.post('eDISTRIBUTOR_SELECTED_CREATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// PUT  ///////
//////////////////
export const updateAdmin = (params) => {
	return (dispatch) => {
		return HttpApi.put('eDISTRIBUTOR_UPDATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const updateStatus = (params) => {
	return (dispatch) => {
		return HttpApi.put('eDISTRIBUTOR_UPDATE_EUserStatus', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const selectedUpdate = (params) => {
	return (dispatch) => {
		return HttpApi.put('eDISTRIBUTOR_SELECTED_UPDATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
///// DELETE /////
//////////////////
export const remove = () => {
    return (dispatch) => {
        return HttpApi.del('eDISTRIBUTOR_DELETE')
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const removeSelectedList = (params) => {
	return (dispatch) => {
		return HttpApi.del('eDISTRIBUTOR_SELECTED_DELETE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

//////////////////
/// FUNCTIONS ////
//////////////////
export const session = () => {
	return (dispatch) => {
		return HttpApi.get('GET_AUTH_SESSION')
			.then((response) => {
				console.log('get-auth-session', response);
				dispatch({ type: ActionTypes.LOGIN, author: response.data });
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const login = (params) => {
	return (dispatch) => {
		return HttpApi.post('eDISTRIBUTOR_LOGIN', params)
			.then((response) => {
				dispatch({ type: ActionTypes.LOGIN, author: response.data });
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getTakeOverList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDAPP_TAKE_OVER_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};


export const getHandOverList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDAPP_HAND_OVER_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const handOver = (params) => {
	return (dispatch) => {
		return HttpApi.post('eDAPP_HAND_OVER', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};
export const takeOver = (params) => {
	return (dispatch) => {
		return HttpApi.post('eDAPP_TAKE_OVER', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getConfirmList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDAPP_CODE_CONFIRM_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getTakeOverListByDate = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDAPP_TAKE_OVER_LIST_BY_DATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getHandOverListByDate = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDAPP_HAND_OVER_LIST_BY_DATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getCodeCheckList = (params) => {
    return (dispatch) => {
        return HttpApi.get('eDAPP_CODE_CHECK_LIST', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};

export const getCodeCheckListByDate = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDAPP_CODE_CHECK_LIST_BY_DATE', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getMyTakeOverList = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDAPP_MY_TAKE_OVER_LIST', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getTakeOverListByDistributor = (params) => {
	return (dispatch) => {
		return HttpApi.get('eDAPP_TAKE_OVER_LIST_BY_DISTRIBUTOR', params)
			.then((response) => {
				return Promise.resolve(response.data);
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	};
};

export const getHandOverListByDistributor = (params) => {
    return (dispatch) => {
        return HttpApi.get('eDAPP_HAND_OVER_LIST_BY_DISTRIBUTOR', params)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((err) => {
                return Promise.reject(err);
            });
    };
};


